import S from 's-js';
import TZDate from 'lib/TZDate';
import { Entrypoints } from 'core/app/entrypoints';
import { ReservationsDashboardResponse, ReservationsDashboardResponseOptions } from 'data/models/ReservationsDashboardResponse';
import { PortCallUserRole } from 'server/enums/PortCallUserRole';
import { UserSummary } from 'data/models/UserSummary';
import { ReservationsDashboardCache } from './cache';
import { DateRange } from 'portcall/daterangeselector/model';
import { ReservationsListBase, ReservationsListBaseParams } from 'portcall/reservationslistbase/model';

export const DefaultRole = PortCallUserRole.Any;
const reservationsFilterStorageKey = "portcall.reservationsdashboard.filter";

export interface ReservationsDashboardParams {
    orgId? : number;
    range : DateRange;
    role? : PortCallUserRole;
    from? : TZDate;
    to? : TZDate;
    filter? : string;
}

export function ReservationsDashboard(
    entrypoints : Entrypoints,
    cache : ReservationsDashboardCache,
    user : () => UserSummary | null,
    baseModel : (params : ReservationsListBaseParams<ReservationsDashboardResponse, ReservationsDashboardResponseOptions>) => ReservationsListBase<ReservationsDashboardResponse>,
    { orgId: _orgId, range, role: _role, from, to, filter } : ReservationsDashboardParams
) {
    const orgId = _orgId !== undefined ? _orgId : user() ? user()!.OrganizationId() : 0,
        role = S.data(_role !== undefined ? _role : DefaultRole),
        base = baseModel({
            cacheCollection: cache.ReservationsDashboardResponses,
            modelKey: ({ FromDate, ToDate }) => ({
                FromDate,
                ToDate,
                OrganizationId: orgId,
                Role: role()
            }),
            organizationRef: model => () => model().Organization(),
            url: entrypoints.ReservationsDashboard,
            filterStorageKey: reservationsFilterStorageKey,
            range, from, to, filter
        });

    return Object.assign({}, base, {
        OrgId: orgId,
        Role: role
    });
}
export type ReservationsDashboard = ReturnType<typeof ReservationsDashboard>;


// WEBPACK FOOTER //
// ./apps/portcall/reservationsdashboard/model.ts